import { ChallengeList } from './ChallengeList';

export default ChallengeList;
